'use client';

import { useEffect } from 'react';

import { applyHashTargetFlash, resolveHashTargetId } from '../lib/hash-target-flash';

export function HashTargetFlash() {
  useEffect(() => {
    let cleanup: (() => void) | undefined;

    const focusHashTarget = () => {
      cleanup?.();
      cleanup = undefined;
      const id = resolveHashTargetId(window.location.hash);
      if (!id) {
        return;
      }
      const el = document.getElementById(id);
      if (!el) {
        return;
      }
      cleanup = applyHashTargetFlash(el);
    };

    focusHashTarget();
    window.addEventListener('hashchange', focusHashTarget);
    return () => {
      cleanup?.();
      window.removeEventListener('hashchange', focusHashTarget);
    };
  }, []);

  return null;
}
